export default class FormularioContacto {

    constructor(selector) {
        this._object = document.querySelector(selector);
        this.listener();
    }

    getObject() {
        return this._object;
    }

    getForm() {
        return new FormData(this.getObject());
    }

    validate() {
        let data = this.getForm();
        const errors = {};

        const nombre = data.get('nombre');
        const mail = data.get('mail');
        const telefono = data.get('telefono');
        const mensaje = data.get('mensaje');

        if (nombre.length < 3) {
            errors.nombre = errors.nombre || [];
            errors.nombre.push('La longitud del nombre debe ser superior a 3 caracteres.');
        }

        if (telefono.length < 10) {
            errors.telefono = errors.telefono || [];
            errors.telefono.push('Verifique que el formato de telefono se ingresó correctamente.');
        }

        if (!mail.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
            errors.mail = errors.mail || [];
            errors.mail.push('Formato de correo electrónico incorrecto.');
        }

        return errors;
    }

    clearErrors() {
        this.getObject()
            .querySelectorAll('.form-group')
            .forEach(element => {
                element.classList.remove('has-error');
            });

        const alert = this.getObject().querySelector('.alert');
        alert.classList.add('hide', 'alert-warning');
        alert.innerHTML = '';
    }

    process_errors(errors) {
        this.clearErrors();

        const alert = this.getObject().querySelector('.alert');
        alert.classList.remove('hide');
        alert.innerHTML = '<ul></ul>';

        const lista = alert.querySelector('ul');

        for (const key of Object.keys(errors)) {
            const element = this.getObject().querySelector('*[name=' + key + ']');
            element.parentNode.classList.add('has-error');
            for (const item of errors[key]) {
                lista.insertAdjacentHTML('beforeend', '<li>' + item + '</li>');
            }
        }

        this.goTop();
    }

    goTop(){
        $("html, body").animate({scrollTop: ($(this.getObject()).offset().top - 100)}, 300);
    }

    submit() {
        this.clearErrors();
        let data = this.getForm();

        const alert = this.getObject().querySelector('.alert');

        try{
            const request = new XMLHttpRequest();
            request.open('POST', '/mail');

            request.onreadystatechange = event => {
                if (request.readyState === XMLHttpRequest.DONE) {
                    if (request.status === 200) {
                        alert.classList.remove('hide', 'alert-warning');
                        alert.classList.add('alert-success');
                        alert.innerHTML = 'Mensaje enviado.';

                        this.goTop();
                        this.getObject().reset();
                        if(window.grecaptcha !== undefined){
                            grecaptcha.reset();
                        }
                    } else {
                        console.log("Error", request.statusText);
                        alert.classList.remove('hide');
                        alert.innerHTML = 'Error al enviar el mensaje. Espere un momento y vuelva a intentar.';
                        this.goTop();
                    }
                }
            };

            request.send(data);
        } catch (e){
            alert.innerHTML = 'Error al enviar el mensaje. Espere un momento y vuelva a intentar.';
            this.goTop();
        }
    }

    listener() {
        this.getObject()
            .addEventListener('submit', (event) => {
                event.preventDefault();
                const error = this.validate();

                if (Object.keys(error).length) {
                    this.process_errors(error);
                    return;
                }

                this.submit();
            });
    }
}


// WEBPACK FOOTER //
// ./js/formulario_contacto.js